import { render, staticRenderFns } from "./Vendedor.vue?vue&type=template&id=20d24af2&scoped=true"
import script from "./Vendedor.vue?vue&type=script&lang=ts"
export * from "./Vendedor.vue?vue&type=script&lang=ts"
import style0 from "./Vendedor.vue?vue&type=style&index=0&id=20d24af2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d24af2",
  null
  
)

export default component.exports